import { render, staticRenderFns } from "./profileSection.vue?vue&type=template&id=39662cc6&"
import script from "./profileSection.vue?vue&type=script&lang=ts&"
export * from "./profileSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports